import { render, staticRenderFns } from "./CopilotPanel.vue?vue&type=template&id=47de82ac&scoped=true&"
import script from "./CopilotPanel.vue?vue&type=script&lang=js&"
export * from "./CopilotPanel.vue?vue&type=script&lang=js&"
import style0 from "./CopilotPanel.vue?vue&type=style&index=0&id=47de82ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de82ac",
  null
  
)

export default component.exports